// Dependent on accounting.js for number formatting

(function ($) {
  const NAMESPACE = 'price-mask';

  $.fn.priceMask = function () {
    const delimiter = $('meta[name=currency_delimiter]').attr('content');
    const separator = $('meta[name=currency_separator]').attr('content');

    return this.each(function () {
      function _hasValue(value) {
        return value !== undefined && value !== '';
      }

      function _format(n) {
        const unformatted = accounting.unformat(n, separator);

        return accounting.formatNumber(unformatted, 2, delimiter, separator);
      }

      function onBlur(input) {
        const n = input.value;
        if (_hasValue(n)) {
          input.value = _format(n);
        }
      }

      $(this).on(`blur.${NAMESPACE}`, function () {
        onBlur(this);
      });
    });
  };

  $(() => {
    $(`[data-plugin=${NAMESPACE}]`).priceMask();
  });
}(jQuery));
